import * as types from './mutation-types'

export default {
  [types.RESET_CURRENT_USER] (state, user) {
    state.currentUser = null
  },
  [types.BOOTSTRAP_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.UPDATE_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.ADD_USER](state, data) {
    state.users.push(data)
  },
  [types.ADD_USERS](state, data) {
    state.users = data.users
  },
  [types.COMPANY_INFO](state, data) {
    state.companyInfo = {
      ...data?.infoGeneral?.tenant_information,
      country: data?.infoGeneral?.country
    }
  },
  [types.ADD_FAMILY_STATUS] (state, data) {
    state.familyStatus = data.data
  },
  [types.STORE_FAMILY_STATUS] (state, data) {
    state.familyStatus = data
  },
  [types.ADD_POST_CATEGORIES] (state, data) {
    state.postCategories = data.data
  },
  [types.STORE_POST_CATEGORIES] (state, data) {
    state.postCategories = data.data
  },
}
